function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'mint': 'rgb(143, 168, 154)','dusty-blue-triblend': 'rgb(143, 168, 154)','blush': 'rgb(221, 143, 139)','tan': 'rgb(196, 185, 150)','military-green': 'rgb(93, 93, 66)','heather-olive': 'rgb(93, 93, 66)','eucalyptus': 'rgb(72, 146, 150)','aspen': 'rgb(189, 204, 172)','raven': 'rgb(91, 89, 92)','orcid': 'rgb(144, 114, 129)','ocean': 'rgb(51, 83, 150)','sand': 'rgb(244, 230, 187)','fern': 'rgb(140, 167, 114)','blossom': 'rgb(240, 173, 196)','ivory': 'rgb(231, 206, 181)','blue-triblend': 'rgb(110, 142, 192)','carolina-blue': 'rgb(110, 142, 192)','solid-carolina-blue-triblend': 'rgb(110, 142, 192)','triblend-red': 'rgb(203, 51, 59)','purple-triblend': 'rgb(97, 75, 121)','purple': 'rgb(97, 75, 121)','berry-triblend': 'rgb(172, 20, 90)','charity-pink-triblend': 'rgb(172, 20, 90)','mint-triblend': 'rgb(168, 213, 186)','triblend-charcoal-black': 'rgb(64, 64, 64)','charcoal-black-triblend': 'rgb(64, 64, 64)','heather-white': 'rgb(217, 217, 221)','ash': 'rgb(217, 217, 221)','tahiti-blue': 'rgb(0, 193, 214)','vintage-red': 'rgb(205, 67, 80)','cardinal-red': 'rgb(205, 67, 80)','red-triblend': 'rgb(205, 67, 80)','triblend-red': 'rgb(205, 67, 80)','triblend-purple': 'rgb(96, 63, 131)','heather-red': 'rgb(205, 67, 80)','heathered-red': 'rgb(205, 67, 80)','heather-sport-scarlet-red': 'rgb(205, 67, 80)','purple-rush': 'rgb(96, 63, 131)','heathered-purple': 'rgb(96, 63, 131)','vintage-black': 'rgb(67, 63, 63)','solid-black-blend': 'rgb(67, 63, 63)','charcoal': 'rgb(128, 128, 128)','athletic-heather': 'rgb(128, 128, 128)','athletic-grey-triblend': 'rgb(128, 128, 128)','heather-true-royal': 'rgb(110, 142, 192)','heather-navy': 'rgb(0, 0, 83)','dusty-blue': 'rgb(168, 213, 186)','mauve': 'rgb(221, 143, 139)','vintage-purple': 'rgb(97, 75, 121)','vintage-navy': 'rgb(0, 0, 83)','navy-triblend': 'rgb(0, 0, 83)','solid-blue-triblend': 'rgb(110, 142, 192)','premium-heather': 'rgb(128, 128, 128)','light-heather-grey': 'rgb(128, 128, 128)','grey-triblend': 'rgb(128, 128, 128)','dark-heather': 'rgb(128, 128, 128)','heathered-charcoal': 'rgb(128, 128, 128)','heathered-lavender': 'rgb(240, 173, 196)','dark-chocolate': 'rgb(62, 43, 46)','pink-triblend': 'rgb(240, 173, 196)','olive-triblend': 'rgb(93, 93, 66)','triblend-athletic-grey': 'rgb(128, 128, 128)','carolina-blue': 'rgb(75, 156, 211)','neon-pink': 'rgb(255, 16, 240)','blue-jean': 'rgb(114, 133, 165)','watermelon': 'rgb(253, 70, 89)','wine': 'rgb(103, 49, 71)','sport-grey': 'rgb(128, 128, 128)','military-green-triblend': 'rgb(93, 93, 66)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
